module.exports = __webpack_public_path__ + "img/Icon.4fb3a17f.svg";